import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import axios from 'axios';

export const getBasketPrice = (basket) =>
  basket?.reduce((amount, item) => item.price * item.qty + amount, 0);

export const getBasketQuantity = (basket) =>
  basket?.reduce((amount, item) => Number(item.qty) + amount, 0);

export const getAllAlbum = createAsyncThunk('album/getAllAlbum', async () => {
  const response = await axios.get('https://music-shop-backend.herokuapp.com/album/all');
  return response.data.data;
});
export const getOneAlbum = createAsyncThunk(
  'album/getOneAlbum',
  async ({id}) => {
    const response = await axios.get(`https://music-shop-backend.herokuapp.com/album/${id}`);
    return response.data.data;
  }
);

export const albumSlice = createSlice({
  name: 'album',
  initialState: {
    basket: [],
    data: [],
    error: null,
  },
  reducers: {
    addToBasket: (state, {payload}) => {
      const item = payload;
      const existItem = state.basket.find((x) => x.id === item.id);
      if (existItem) {
        state.basket = state.basket.map((x) => {
          return x.id === existItem.id ? item : x;
        });
      } else {
        state.basket = [...state.basket, item];
      }
    },
    removeFromBasket: (state, {payload}) => {
      state.basket = state.basket.filter((x) => x.id !== payload);
    },
    emptyBasket: (state) => {
      state.basket = [];
    },
  },
  extraReducers: {
    [getAllAlbum.pending]: (state) => {
      state.status = 'loading';
    },
    [getAllAlbum.fulfilled]: (state, {payload}) => {
      state.data = payload;
      state.status = 'success';
    },

    [getAllAlbum.rejected]: (state, action) => {
      state.status = 'failed';
      state.error = action.error.message;
    },
    [getOneAlbum.pending]: (state) => {
      state.status = 'loading';
    },
    [getOneAlbum.fulfilled]: (state, {payload}) => {
      state.data = payload;
      state.status = 'success';
    },

    [getOneAlbum.rejected]: (state, action) => {
      state.status = 'failed';
      state.error = action.error.message;
    },
  },
});

export const {addToBasket, removeFromBasket, emptyBasket} = albumSlice.actions;
export const albumSelector = (state) => state.album;

export default albumSlice.reducer;
